import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';
import { Footer } from 'marketing-components';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export default class Footercontainer extends React.Component {
  constructor(props) {
    super(props);
  }

  renderFooter() {
    const { isNewMppEnabled, footer } = this.props;

    // IF remote config based MPP is enabled
    if (JSON.parse(isNewMppEnabled)) {
      const footerContent = JSON.parse(footer); // Parse the stringified content

      // if(this.props.locale === 'en_US' && this.props.country === 'vn'){
      //   content.country.locales = [ { text: 'Vietnamese', href: '?locale.x=vi_VN' } ];
      // }
      // if(this.props.country !== 'kr' && this.props.country !== 'vn'){
      //   content.country.locales = [];
      // }
      return <Footer {...footerContent} />;
    } else {
      return getHTMLElement(footer, { useHTML: true });
    }
  }
  render() {
    const { country, locale, useGlobalNav } = this.props;

    if (JSON.parse(useGlobalNav)) {
      return <NavFragment type="footer" />;
    }
    const fontChange =
      country === 'vn' && locale === 'vi_VN'
        ? 'vnFont'
        : country === 'jp' && locale === 'ja_JP'
        ? 'jpFont'
        : '';

    return <section className={fontChange}>{this.renderFooter()}</section>;
  }
}

Footercontainer.propTypes = {
  footer: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
  useGlobalNav: PropTypes.string,
};
